import { message, Modal } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import * as documentFunction from 'components/UIBuilder/SectionFunction/Document';

//上传File
export function uploadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let documentComponent = globalFunction.getSectionComponent(pageComponent, 'Document');
  documentFunction.addBySection({ sectionComponent: documentComponent, pageComponent: pageComponent });
  pageComponent.setState({ uploadType: 'JobRequiredCertificateClientDocument', jobRequiredCertificateId: parameter.key });
  setTimeout(() => {
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
  }, config.setTimeoutMilliSecond);
}

//删除File
export function deleteJobRequiredCertificateClientDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .delete('Business/JobRequiredCertificate/DeleteJobRequiredCertificateClientDocument/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//public上传File
export function publicUploadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let documentComponent = globalFunction.getSectionComponent(pageComponent, 'ReceivedDocument');
  documentFunction.addBySection({ sectionComponent: documentComponent, pageComponent: pageComponent });
  pageComponent.setState({ uploadType: 'JobRequiredCertificateClientDocument', jobRequiredCertificateId: parameter.key });
  setTimeout(() => {
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
  }, config.setTimeoutMilliSecond);
}

//public删除File
export function deletePublicJobRequiredCertificateClientDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .delete('Business/JobRequiredCertificate/DeletePublicJobRequiredCertificateClientDocument/' + parameter.key + '?accessCode=' + pageComponent.state.accessCode)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
